import { useContext } from 'react';
import ConfirmContext from '../store/ConfirmContext';
import { HIDE_CONFIRM, SHOW_CONFIRM } from '../store/Reducer';

function useConfirm() {
  const [confirmState, dispatch, pending] = useContext(ConfirmContext);
  const confirm = text => {
    if (pending.current) return Promise.resolve(false);
    return new Promise(resolve => {
      pending.current = resolve;
      dispatch({ type: SHOW_CONFIRM, payload: { text } });
    });
  };
  const finish = value => {
    const resolve = pending.current;
    pending.current = null;
    dispatch({ type: HIDE_CONFIRM });
    resolve?.(value);
  };
  return { confirm, onConfirm: () => finish(true), onCancel: () => finish(false), confirmState };
}
export default useConfirm;
